import React from 'react';
import { Action, withInject } from '@piwikpro/platform';
import { TFunction } from 'react-i18next';
import {
  Stack,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import { App, Apps } from '@piwikpro/apps-crate';

interface Props {
  apps: Apps
  app: App
  t: TFunction
}

class TdddgCompliance extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, { setFieldValue, setSubmitting }) {
    const { apps, app } = this.props;

    try {
      await apps.update(app.id, values);
    } catch (err) {
      setFieldValue('sessionIdStrictPrivacyMode', !values.sessionIdStrictPrivacyMode, false);
    }

    setSubmitting(false);
  }

  render() {
    const {
      app,
      t,
    } = this.props;

    return (
      <Stack wrap verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.tdddgCompliance.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.tdddgCompliance.description')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Action.AutoSavedSwitcherControl
            id="app-settings-tdddg-compliance"
            initialValue={app.attributes.sessionIdStrictPrivacyMode}
            name="sessionIdStrictPrivacyMode"
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default withInject({
  apps: 'AppsCrate.apps',
})(
  withTranslation(['administration'])(TdddgCompliance),
);
